var App = App || {};

App.Header = (function ($) {
    'use strict';

    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 200;
        const mmTimer = 300;

        let mmOpenTimer;
        let mmCloseTimer;

        const mmContainer = $("header .header-primary > nav > ul");
        const mmTrigger = mmContainer.children("li").children("a, button");
        const mmItems = mmContainer.find(".mega-menu").find("a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        mmItems.attr("tabindex", -1);

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            mmTrigger.trigger("blur");

            mmCloseTimer = window.setTimeout(function () {
                MegaMenuClose(mmTrigger, mmSpeed);
            }, mmTimer);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                mmActive = false;
                MegaMenuClose($(this).children("li").children("a, button"), 1);
            }
        });

        mmTrigger.on("click focus mouseenter", function (e) {
            var $this = $(this);
            var mmTimerFocus = mmTimer;

            window.clearTimeout(mmOpenTimer);

            if (e.type === "click" || e.type === "focus") {
                if (e.type === "click") {
                    e.preventDefault();
                }

                mmTimerFocus = 1;
            }

            mmOpenTimer = window.setTimeout(function () {
                MegaMenuOpen($this, mmSpeed);
            }, mmTimerFocus);

            mmActive = true;
        }).on("blur mouseleave", function () {
            window.clearTimeout(mmOpenTimer);

            if (mmActive === false) {
                mmCloseTimer = window.setTimeout(function () {
                    MegaMenuClose($(this), mmSpeed);
                }, mmTimer);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItems = [];
                    mmActiveItem = 0;
                    $(this).siblings(".mega-menu").find("a:visible").each(function () { mmActiveItems.push(this); });
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    MegaMenuClose($(this), mmSpeed);
                    break;
            }
        });

        mmItems.on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".mega-menu").parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".mega-menu").parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, megaMenuSpeed);
                    break;
            }
        });
    }

    function MegaMenuOpen(trigger, speed) {
        trigger.attr("aria-expanded", "true").siblings(".mega-menu").stop().removeClass("animate__fadeOut").addClass("animate__fadeIn").show();
        MegaMenuClose(trigger.parents("li").siblings("li").children("a, button"), speed);
        App.Base.ShowDropdownBackdrop();
    }

    function MegaMenuClose(trigger, speed) {
        trigger.attr("aria-expanded", "false").siblings(".mega-menu").stop().removeClass("animate__fadeIn").addClass("animate__fadeOut");

        setTimeout(function () {
            trigger.siblings(".mega-menu").hide();
        }, speed);

        if (trigger.parents("li").siblings("li").children("[aria-expanded='true']").length === 0) {
            App.Base.HideDropdownBackdrop();
        }
    }

    function MobileMenu() {
        const dropdownToggle = $("#menu");
        const dropdown = $("#dropdown-mobile-menu");
        const levels = dropdown.find(".mobile-menu-levels");
        const buttons = dropdown.find("button[data-mobilemenu]");

        dropdownToggle.on("hidden.bs.dropdown", function () {
            levels.attr("data-level", 1);
            levels.find(".mobile-menu-level-item").removeClass("active");
            levels.find(".mobile-menu-level[data-level='1'] .mobile-menu-level-item").addClass("active");
        });

        buttons.on("click", function () {
            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels.find(`.mobile-menu-level[data-level="${currentLevel}"]`)
                .find(".mobile-menu-level-item.active");

            const nextItem = $(`#${$(this).attr("aria-controls")}`);
            const nextLevel = parseInt(nextItem.parents(".mobile-menu-level").attr("data-level"));

            currentItem.removeClass("active");
            nextItem.addClass("active");

            levels.attr("data-level", nextLevel);
        });
    }

    return {
        MegaMenu: MegaMenu,
        MobileMenu: MobileMenu
    };

})(jQuery);